// extracted by mini-css-extract-plugin
export default {"notFoundPage":"style_notFoundPage__Lr66i","notFoundBlock":"style_notFoundBlock__8wLmd"};